import React from "react";

export default function ContentTakedownPolicy() {
  return (
    <div className="max-w-4xl mx-auto px-6 py-10 text-gray-800 leading-relaxed">
      <h1 className="text-3xl font-semibold mb-6">PRObroker Content Takedown Policy</h1>

      <p className="mb-4"><strong>Last Updated:</strong> 09/02/2026</p>

      <p className="mb-4">
        This Policy applies to reports of incorrect or outdated property data, allegations of unlawful, infringing, or harmful content hosted or displayed on PRObroker as well as requests for temporary disabling of access to specific content pending review.
      </p>

      <p className="mb-4">
        Any user may report content by emailing the Grievance Officer, or Reports should contain URL or unique identifier of the listing/content, Detailed description of the issue (incorrect data, alleged illegality, infringement, etc.), Supporting documentation, where relevant.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3">Review and Takedown Timelines:</h2>

      <p className="mb-4">
        On receipt of a report, we will acknowledge the report as per our internal Grievance Redressal Methods. We will conduct a preliminary review to classify the issue concerning incorrectness of data, alleged illegality and source of original information.
      </p>

      <p className="mb-4">
        For clearly unlawful content notified with appropriate court or government orders, we will act expeditiously to remove or disable access as required under the IT Rules, typically within 36 hours of receiving such order.
      </p>

      <p className="mb-4">For incorrect or outdated property data:</p>

      <ul className="list-disc pl-6 mb-4 space-y-2">
        <li>We will attempt to verify the information with available sources and stakeholders.</li>
        <li>Where the report appears credible, we may temporarily flag or hide the content while verification is ongoing.</li>
        <li>Our target is to correct or decide on such content within 7 to 14 days, depending on complexity.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-8 mb-3">Temporary Disabling Powers:</h2>

      <p className="mb-4">
        PRObroker reserves the right to temporarily disable or restrict access to any content or listing where:
      </p>

      <ul className="list-disc pl-6 mb-4 space-y-2">
        <li>There is a prima facie case of illegality, infringement or serious risk.</li>
        <li>The reported data is likely to be materially misleading or harmful.</li>
        <li>There is non cooperation from the relevant user/broker in clarifying or correcting the content.</li>
      </ul>

      <p className="mb-4">
        Temporary disabling does not amount to a finding of guilt, it is meant to be a risk mitigation measure pending investigation.
      </p>

      <p className="mb-4">
        Where feasible and not prohibited by law, we will notify the user who uploaded or is associated with the content regarding the fact of takedown or disabling, with generalized reason (e.g., alleged infringement, inaccurate data), the opportunity to respond or provide supporting documentation within a specified timeframe.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3">Correction of Property Data:</h2>

      <p className="mb-4">
        Property owners or authorised representatives may request correction or removal of specific property related information by submitting evidence of ownership and the correct information.
      </p>

      <p className="mb-4">
        Brokers are encouraged to proactively request updates when they become aware that a listing is no longer accurate (e.g., property sold, price changed, withdrawn).
      </p>

      <p className="mb-4">
        We may annotate content with “updated”, “under verification”, or similar labels while corrections are being processed.
      </p>
    </div>
  );
}
